import { IAuthService } from '@velociti/core'
import { App } from '@capacitor/app'
import { Network } from '@capacitor/network'
import { TENANT_REFRESH_INTERVAL } from 'src/system/auth/lib/services/auth'

const Boot = ({ app }) => {
  const authService = app._context.provides['authService'] as IAuthService

  const doRefresh = async (force = false) => {
    const status = await Network.getStatus()
    if (!status.connected) {
      console.debug('Network is not connected, skipping tenant refresh')
      return
    }

    try {
      authService.refreshTenantConfig()
    } catch (e) {
      console.error('Error refreshing tenant configuration:', e)
    }
  }

  // Listen for app resume events
  App.addListener('resume', () => {
    //console.log('App resumed, refreshing tenant configuration...')
    doRefresh()
  })

  // Start an interval timer to refresh tenant configuration every 5 minutes
  setInterval(() => {
    doRefresh()
  }, TENANT_REFRESH_INTERVAL)

  // Refresh immediately on boot
  doRefresh(true)
}

export default Boot
